import { useCallback } from "react";

import type * as Type from "../type";

type onFinishCallbackProps = {
	tagList: Array<string>;
	regionTag?: string;
	prefectureTag?: string;
	cityTag?: string;
};
type Props = {
	viewModel: Type.ViewModel;
	onOpenChange: (open: boolean) => void;
	onFinishCallback: (props: onFinishCallbackProps) => void;
};

export const useHandleFinish = ({ viewModel, onOpenChange, onFinishCallback }: Props) => {
	/**
	 * 完了時の処理
	 */
	const onFinish = useCallback(() => {
		onFinishCallback({
			tagList: viewModel.selectedTagList,
			regionTag: viewModel.selectedRegionTag,
			prefectureTag: viewModel.selectedPrefectureTag,
			cityTag: viewModel.selectedCityTag,
		});
		onOpenChange(false);
	}, [
		onFinishCallback,
		onOpenChange,
		viewModel.selectedCityTag,
		viewModel.selectedPrefectureTag,
		viewModel.selectedRegionTag,
		viewModel.selectedTagList,
	]);

	return {
		onFinish,
	};
};
